export default __webpack_public_path__ + "static/test_2_4-368e0a8c7210ef81c0e496c479ad297b.png";